(() => {
  if (window.__productBundleOfferLoaded) return;
  window.__productBundleOfferLoaded = true;

  const selector = '[data-product-bundle-offer]';

  const formatMoney = (cents, root) => {
    const currency = root.dataset.currencyCode || window.Shopify?.currency?.active || 'EUR';
    const value = (Number(cents) || 0) / 100;

    return value.toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency,
    });
  };

  const formatPercent = (ratio) =>
    ratio.toLocaleString(document.documentElement.lang || undefined, {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    });

  const selectedInputs = (root) =>
    [...root.querySelectorAll('[data-product-bundle-checkbox]')].filter((input) => {
      const available = input.dataset.available !== 'false';
      return available && input.checked && input.dataset.variantId;
    });

  const updateBundle = (root) => {
    const inputs = selectedInputs(root);
    const total = inputs.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
    const compareAtTotal = inputs.reduce((sum, input) => {
      const price = Number(input.dataset.price || 0);
      const compareAt = Number(input.dataset.compareAt || price);
      return sum + (compareAt > price ? compareAt : price);
    }, 0);
    const savings = inputs.reduce((sum, input) => {
      const price = Number(input.dataset.price || 0);
      const compareAt = Number(input.dataset.compareAt || price);
      const referencePrice = compareAt > price ? compareAt : price;
      return sum + referencePrice - price;
    }, 0);

    const totalTarget = root.querySelector('[data-product-bundle-total]');
    const compareAtTotalTarget = root.querySelector('[data-product-bundle-compare-total]');
    const savingsTarget = root.querySelector('[data-product-bundle-savings]');
    const submit = root.querySelector('[data-product-bundle-submit]');
    const savingsTemplate = root.dataset.savingsTemplate || 'Poupa [savings] ([percentage]) em relação ao PVPR.';

    if (totalTarget) totalTarget.textContent = formatMoney(total, root);

    if (compareAtTotalTarget) {
      compareAtTotalTarget.hidden = savings <= 0;
      const compareAtValue = compareAtTotalTarget.querySelector('s');
      if (compareAtValue) compareAtValue.textContent = savings > 0 ? formatMoney(compareAtTotal, root) : '';
    }

    if (savingsTarget) {
      savingsTarget.hidden = savings <= 0;
      const percent = compareAtTotal > 0 ? savings / compareAtTotal : 0;
      const template = savingsTemplate.includes('[percentage]')
        ? savingsTemplate
        : savingsTemplate.replaceAll('[savings]', '[savings] ([percentage])');
      savingsTarget.textContent =
        savings > 0
          ? template
              .replaceAll('[savings]', formatMoney(savings, root))
              .replaceAll('[percentage]', formatPercent(percent))
          : '';
    }

    if (submit) submit.disabled = inputs.length === 0;
  };

  const getFreshCartSections = (cart) => {
    const sectionIds = cart.getSectionsToRender().map((section) => section.id);
    const url = `${window.routes.cart_url}?sections=${sectionIds.join(',')}`;

    return fetch(url).then((sectionResponse) => sectionResponse.json());
  };

  const renderCart = (cart, response, trigger) => {
    if (!cart) {
      window.location = window.routes.cart_url;
      return Promise.resolve();
    }

    cart.setActiveElement?.(trigger);
    cart.classList?.remove('is-empty');

    return getFreshCartSections(cart)
      .then((sections) => {
        const parsedState = {
          ...response,
          sections,
        };

        if (response.items?.[0]?.key && !parsedState.key) parsedState.key = response.items[0].key;
        cart.renderContents(parsedState);
      })
      .catch((error) => {
        console.error(error);
        if (response.sections) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      });
  };

  const submitBundle = (root) => {
    const submit = root.querySelector('[data-product-bundle-submit]');
    const spinner = submit?.querySelector('.loading__spinner');
    const errorTarget = root.querySelector('[data-product-bundle-error]');
    const inputs = selectedInputs(root);
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!submit || inputs.length === 0 || submit.getAttribute('aria-disabled') === 'true') return;

    if (errorTarget) {
      errorTarget.hidden = true;
      errorTarget.textContent = '';
    }

    submit.setAttribute('aria-disabled', 'true');
    submit.classList.add('loading');
    spinner?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({
      items: inputs.map((input) => ({
        id: Number(input.dataset.variantId),
        quantity: 1,
      })),
      sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (errorTarget) {
            errorTarget.textContent = response.description || response.message || window.cartStrings?.error || '';
            errorTarget.hidden = false;
          }
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-bundle-offer',
          cartData: response,
        });
        return renderCart(cart, response, submit);
      })
      .catch((error) => {
        console.error(error);
        if (errorTarget) {
          errorTarget.textContent = window.cartStrings?.error || 'Não foi possível adicionar ao carrinho.';
          errorTarget.hidden = false;
        }
      })
      .finally(() => {
        submit.classList.remove('loading');
        submit.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
      });
  };

  const initBundle = (scope = document) => {
    scope.querySelectorAll(selector).forEach((root) => {
      if (root.dataset.productBundleReady === 'true') return;

      root.dataset.productBundleReady = 'true';
      root.querySelectorAll('[data-product-bundle-checkbox]').forEach((input) => {
        input.addEventListener('change', () => updateBundle(root));
      });
      root.querySelector('[data-product-bundle-submit]')?.addEventListener('click', () => submitBundle(root));
      updateBundle(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBundle());
  } else {
    initBundle();
  }

  document.addEventListener('shopify:section:load', (event) => initBundle(event.target));
  document.addEventListener('product-recommendations:loaded', (event) => initBundle(event.target));
})();
